import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'ui'
import { ControlledField } from './ControlledField'
import { SigningFormFieldProps } from './Switcher'

export const SelectField = (props: SigningFormFieldProps) => {
  return (
    <ControlledField {...props}>
      {({ field: formField }) => {
        return (
          <Select
            defaultValue={formField.value}
            onValueChange={(value) => {
              formField.onChange(value)
              props.onPersist(value)
            }}
          >
            <SelectTrigger
              style={{
                fontSize: 'inherit',
              }}
              id={props.field.id}
              className='w-full h-full rounded-none focus-visible:ring-black p-0'
            >
              <SelectValue placeholder='Selecciona una opción' />
            </SelectTrigger>
            <SelectContent>
              {props.field.options?.map((opt, index) => {
                return (
                  <SelectItem key={index} value={opt.value}>
                    {opt.value}
                  </SelectItem>
                )
              })}
            </SelectContent>
          </Select>
        )
      }}
    </ControlledField>
  )
}
